<template>
  <v-container grid-list-md class="pt-0 px-0 ma-0">
    <v-row>
      <v-col cols="12" class="pt-0">
        <v-card flat v-if="lAction === 'view'">
          <v-card-title class="pa-2">
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <v-layout row wrap>
                    <v-flex xs5>
                      <v-dialog ref="dlgFromDate"
                      persistent v-model="dlgFromDate"
                      max-width="290px"
                      :return-value.sync="fromDate">
                      <template v-slot:activator="{ on }">
                        <v-text-field
                        slot="activator" label="From"
                        v-model="fromDate" append-icon="mdi-calendar-today"
                        readonly clearable
                        v-on="on"
                        hide-details
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="fromDate"
                      first-day-of-week="1">
                      <v-spacer></v-spacer>
                      <v-btn text @click="dlgFromDate = false">Cancel</v-btn>
                      <v-btn text color="accent" @click="$refs.dlgFromDate.save(fromDate)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex xs5 class="pl-1">
                  <v-dialog ref="dlgToDate"
                  persistent v-model="dlgToDate"
                  max-width="290px"
                  :return-value.sync="toDate"
                  >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                    label="To"
                    v-model="toDate" append-icon="mdi-calendar-today"
                    readonly clearable hide-details
                    v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="toDate" scrollable
                  first-day-of-week="1"
                  >
                  <v-spacer></v-spacer>
                  <v-btn text @click="dlgToDate = false">Cancel</v-btn>
                  <v-btn text color="accent" @click="$refs.dlgToDate.save(toDate)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
            <v-flex xs2 class="text-left pa-2">
              <v-btn small fab class="accent" @click="loadEmployeeDet()">Go</v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 sm6 class="pa-2">
          <v-text-field
          append-icon="mdi-account-search"
          :placeholder="$vuetify.breakpoint.smAndUp?'Search by Community Name':'Search'"
          hide-details
          v-model="search"
          outlined
          clearable
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs6 class="pa-0">
      <v-btn @click="showLeftEmployees(true)">Show Left Employees({{leftEmp.length}})</v-btn>
    </v-flex>
    <v-flex xs6 class="pt-0">
      <v-download-as
      :headers="empDetailsHeader"
      :items="empDet"
      title="HR Dashboard"
      landscape="true"
      ></v-download-as>
    </v-flex>
  </v-card-title>
  <v-card-text class="pa-2">
    <v-layout row wrap>
      <v-flex xs12 class="pa-0" mx-auto>
        <div style="border: 1px solid black;">
          <v-data-table
          :headers="empDetailsHeader"
          :items="empDet"
          hide-default-footer
          hide-default-header
          disable-pagination
          height="475"
          fixed-header
          :search="search"
          :mobile-breakpoint="0"
          class="elevation-1"
          >
          <template v-slot:header="{ props: { headers } }">
            <thead>
              <tr>
                <th class="teal lighten-1" style="width: 246px; font-size: 12px; border-top: 1px solid black; border-right: 1px solid black;color:#fff;">{{headers[0].text}}</th>
                <th class="teal lighten-1" style="width: 150px; font-size: 12px; border-top: 1px solid black; border-right: 1px solid black;color:#fff;">{{headers[1].text}}</th>
                <th class="teal lighten-1" style="width: 246px; font-size: 12px; border-top: 1px solid black; border-right: 1px solid black;color:#fff;">{{headers[2].text}}</th>
                <th class="teal lighten-1" style="width: 246px; font-size: 12px; border-top: 1px solid black; border-right: 1px solid black;color:#fff;">{{headers[3].text}}</th>
                <th class="teal lighten-1" style="width: 246px; font-size: 12px; border-top: 1px solid black; border-right: 1px solid black;color:#fff;">{{headers[4].text}}</th>
                <th class="teal lighten-1" style="width: 246px; font-size: 12px; border-top: 1px solid black; border-right: 1px solid black;color:#fff;">{{headers[5].text}}</th>
                <th class="teal lighten-1" style="width: 246px; font-size: 12px; border-top: 1px solid black; border-right: 1px solid black;color:#fff;">{{headers[6].text}}</th>
                <th class="teal lighten-1" style="width: 246px; font-size: 12px; border-top: 1px solid black; border-right: 1px solid black;color:#fff;">{{headers[7].text}}</th>
                <th class="teal lighten-1" style="width: 246px; font-size: 12px; border-top: 1px solid black; border-right: 1px solid black;color:#fff;">{{headers[8].text}}</th>
              </tr>
            </thead>
          </template>
          <template slot="item" slot-scope="props">
            <tr  :class="props.index === (empDet.length - 1) ? 'teal lighten-3' : ''" :style="props.index === (empDet.length - 1) ? 'color:#fff; font-weight: bold;' : props.index % 2 === 0 ? 'backgroundColor: #bfbfbf; cursor: pointer;' : 'backgroundColor: #e0e0e0; cursor: pointer;'">
              <td style="width: 246px; font-size: 12px; border-top: 1px solid black; border-right: 1px solid black;">{{ props.item.comm_name }}</td>
              <td @click="showListofStaffBasedonCommunity(props.item, 'Staff (Deployed | Undeployed)')" style="width: 150px; font-size: 12px; border-top: 1px solid black; border-right: 1px solid black;" class="text-center">{{ props.item.staff }}</td>
              <td @click="showListofStaffBasedonCommunity(props.item, 'AADHAR Collected | Pending')" style="width: 246px; font-size: 12px; border-top: 1px solid black; border-right: 1px solid black;" class="text-center">{{ props.item.documents }}</td>
              <td @click="showListofStaffBasedonCommunity(props.item, 'PF No Generated | Pending')" style="width: 246px; font-size: 12px; border-top: 1px solid black; border-right: 1px solid black;" class="text-center">{{ props.item.pf }}</td>
              <td @click="showListofStaffBasedonCommunity(props.item, 'ESI No Generated | Pending')" style="width: 246px; font-size: 12px; border-top: 1px solid black; border-right: 1px solid black;" class="text-center">{{ props.item.esi }}</td>
              <td @click="showListofStaffBasedonCommunity(props.item, 'ESI card not Generated')" style="width: 246px; font-size: 12px; border-top: 1px solid black; border-right: 1px solid black;" class="text-center">{{ props.item.esic_card_not_generated }}</td>
              <td @click="showListofStaffBasedonCommunity(props.item, 'Bank Acc. # Not Updated')" style="width: 246px; font-size: 12px; border-top: 1px solid black; border-right: 1px solid black;" class="text-center">{{ props.item.bank_acc_no_updated }}</td>
              <td @click="showListofStaffBasedonCommunity(props.item, 'PAN No Updated')" style="width: 246px; font-size: 12px; border-top: 1px solid black; border-right: 1px solid black;" class="text-center">{{ props.item.pan_no_updated }}</td>
              <td @click="showListofStaffBasedonCommunity(props.item, 'BGV Done | Not Done')" style="width: 246px; font-size: 12px; border-top: 1px solid black; border-right: 1px solid black;" class="text-center">{{ props.item.verif }}</td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-flex>
  </v-layout>
</v-card-text>
</v-card>

<!-- showing emp name when user clicks on any column other than "TOTAL" -->
<v-dialog v-model="showEmpList" max-width="750px">
  <v-card>
    <v-card-title class="py-2 px-3 title grey lighten-3">
      <div>{{typeAndHeaderTitle.comm_name}} - {{typeAndHeaderTitle.type}}</div>
      <v-spacer></v-spacer>
      <v-btn icon small @click="showEmpList = false"><v-icon>mdi-close</v-icon></v-btn>
      <v-flex xs12 class="pt-3">
        <v-download-as
        :headers="empListHeader"
        :items="empList"
        title="Employee List"
        ></v-download-as>
      </v-flex>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
      :headers="empListHeader"
      :items="empList"
      hide-default-footer
      disable-pagination
      :mobile-breakpoint="0"
      >
      <template slot="item" slot-scope="props">
        <tr>
          <td>{{ props.item.serial_no }}</td>
          <td>{{ props.item.vendor_emp_id }}</td>
          <td>{{ props.item.emp_name }}</td>
          <td>{{ props.item.emp_desig }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-card>
</v-dialog>

<!-- Deployed and Undeployed Staff -->
<v-dialog v-model="showDepandUndepStaff" max-width="600px" class="white">
  <v-card>
    <v-card-title class="py-2 px-3 title grey lighten-3">
      <div>{{typeAndHeaderTitle.comm_name}} - Deployed and Undeployed Staff</div>
      <v-spacer></v-spacer>
      <v-btn icon small @click="showDepandUndepStaff = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-divider></v-divider>
      <v-flex xs12>
        <div class="py-2 px-3 title grey lighten-3">Undeployed Staff</div>
        <v-data-table
        :headers="empListHeader"
        :items="UnDepEmp"
        hide-default-footer
        disable-pagination
        :mobile-breakpoint="0"
        >
        <template slot="item" slot-scope="props">
          <tr>
            <td>{{ props.item.serial_no }}</td>
            <td>{{ props.item.vendor_emp_id }}</td>
            <td>{{ props.item.emp_name }}</td>
            <td>{{ props.item.emp_desig }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
    <v-divider class="mb-2"></v-divider>
    <v-flex xs12>
      <div class="py-2 px-3 title grey lighten-3">Deployed Staff</div>
      <v-data-table
      :headers="empListHeader"
      :items="DepEmp"
      hide-default-footer
      disable-pagination
      :mobile-breakpoint="0"
      >
      <template slot="item" slot-scope="props">
        <tr>
          <td>{{ props.item.serial_no }}</td>
          <td>{{ props.item.vendor_emp_id }}</td>
          <td>{{ props.item.emp_name }}</td>
          <td>{{ props.item.emp_desig }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-flex>
</v-card-text>
</v-card>
</v-dialog>

<!-- AADHAR Card collected and Pending -->
<v-dialog v-model="showDocCollectedAndPending" max-width="700px" class="white">
  <v-card>
    <v-card-title class="py-2 px-3 title grey lighten-3">
      <div>{{typeAndHeaderTitle.comm_name}} - AADHAR Card Collected &amp; Pending</div>
      <v-spacer></v-spacer>
      <v-btn icon small @click="showDocCollectedAndPending = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-divider></v-divider>
      <v-flex xs12>
        <div class="py-2 px-3 title grey lighten-3">AADHAR card pending</div>
        <v-data-table
        :headers="empListHeader"
        :items="pendDocEmp"
        hide-default-footer
        disable-pagination
        :mobile-breakpoint="0"
        >
        <template slot="item" slot-scope="props">
          <tr>
            <td>{{ props.item.serial_no }}</td>
            <td>{{ props.item.vendor_emp_id }}</td>
            <td>{{ props.item.emp_name }}</td>
            <td>{{ props.item.emp_desig }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
    <v-divider class="mb-2"></v-divider>
    <v-flex xs12>
      <div class="py-2 px-3 title grey lighten-3">AADHAR card collected</div>
      <v-data-table
      :headers="empListHeader"
      :items="collectedDocEmp"
      hide-default-footer
      disable-pagination
      :mobile-breakpoint="0"
      >
      <template slot="item" slot-scope="props">
        <tr>
          <td>{{ props.item.serial_no }}</td>
          <td>{{ props.item.vendor_emp_id }}</td>
          <td>{{ props.item.emp_name }}</td>
          <td>{{ props.item.emp_desig }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-flex>
</v-card-text>
</v-card>
</v-dialog>

<!-- PF Generated and Pending -->
<v-dialog v-model="showPFGeneratedandPend" max-width="750px" class="white">
  <v-card>
    <v-card-title class="py-2 px-3 title grey lighten-3">
      <div>{{typeAndHeaderTitle.comm_name}} - PF Generated &amp; Pending</div>
      <v-spacer></v-spacer>
      <v-btn icon small @click="showPFGeneratedandPend = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-divider></v-divider>
      <v-flex xs12 class="py-2 px-3 title grey lighten-3">
        <v-layout row wrap>
          <v-flex xs6 class="px-2 py-2">
            <div>Pending PF</div>
          </v-flex>
          <v-flex xs6 class="px-2 py-2">
            <v-download-as
            :headers="pfHeader"
            :items="pfPendEmp"
            title="Pending PF"
            landscape="true"
            ></v-download-as>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <v-data-table
        :headers="pfHeader"
        :items="pfPendEmp"
        hide-default-footer
        disable-pagination
        :mobile-breakpoint="0"
        >
        <template slot="item" slot-scope="props">
          <tr>
            <td>{{ props.item.serial_no }}</td>
            <td>{{ props.item.vendor_emp_id }}</td>
            <td>{{ props.item.emp_name }}</td>
            <td>{{ props.item.emp_desig }}</td>
            <td>{{ props.item.pf_no ? props.item.pf_no : '-' }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
    <v-divider class="mb-2"></v-divider>
    <v-flex xs12 class="py-2 px-3 title grey lighten-3">
      <v-layout row wrap>
        <v-flex xs6 class="py-2 px-2">
          <div>Generated PF</div>
        </v-flex>
        <v-flex xs6 class="py-2 px-2">
          <v-download-as
          :headers="pfHeader"
          :items="pfEmp"
          title="Generated PF"
          landscape="true"
          ></v-download-as>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12>
      <v-data-table
      :headers="pfHeader"
      :items="pfEmp"
      hide-default-footer
      disable-pagination
      :mobile-breakpoint="0"
      >
      <template slot="item" slot-scope="props">
        <tr>
          <td>{{ props.item.serial_no }}</td>
          <td>{{ props.item.vendor_emp_id }}</td>
          <td>{{ props.item.emp_name }}</td>
          <td>{{ props.item.emp_desig }}</td>
          <td>{{ props.item.pf_no }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-flex>
</v-card-text>
</v-card>
</v-dialog>

<!-- ESI No Generated and Pending -->
<v-dialog v-model="showESIGeneratedandPend" max-width="750px" class="white">
  <v-card>
    <v-card-title class="py-2 px-3 title grey lighten-3">
      <div>{{typeAndHeaderTitle.comm_name}} - ESI No Generated &amp; Pending</div>
      <v-spacer></v-spacer>
      <v-btn icon small @click="showESIGeneratedandPend = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-divider></v-divider>
      <v-flex xs12 class="py-2 px-3 title grey lighten-3">
        <v-layout row wrap>
          <v-flex xs6 class="py-2 px-2">
            <div>Pending ESI</div>
          </v-flex>
          <v-flex xs6 class="py-2 px-2">
            <v-download-as
            :headers="esiHeader"
            :items="esiPendEmp"
            title="Pending ESI"
            landscape="true"
            ></v-download-as>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <v-data-table
        :headers="esiHeader"
        :items="esiPendEmp"
        hide-default-footer
        disable-pagination
        :mobile-breakpoint="0"
        >
        <template slot="item" slot-scope="props">
          <tr>
            <td>{{ props.item.serial_no }}</td>
            <td>{{ props.item.vendor_emp_id }}</td>
            <td>{{ props.item.emp_name }}</td>
            <td>{{ props.item.emp_desig }}</td>
            <td>{{ props.item.esi_no?props.item.esi_no:'-' }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
    <v-divider class="mb-2"></v-divider>
    <v-flex xs12 class="py-2 px-3 title grey lighten-3">
      <v-layout row wrap>
        <v-flex xs6 class="py-2 px-2">
          <div>Generated ESI</div>
        </v-flex>
        <v-flex xs6 class="py-2 px-2">
          <v-download-as
          :headers="esiHeader"
          :items="esiEmp"
          title="Generated ESI"
          landscape="true"
          ></v-download-as>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12>
      <v-data-table
      :headers="esiHeader"
      :items="esiEmp"
      hide-default-footer
      disable-pagination
      :mobile-breakpoint="0"
      >
      <template slot="item" slot-scope="props">
        <tr>
          <td>{{ props.item.serial_no }}</td>
          <td>{{ props.item.vendor_emp_id }}</td>
          <td>{{ props.item.emp_name }}</td>
          <td>{{ props.item.emp_desig }}</td>
          <td>{{ props.item.esi_no }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-flex>
</v-card-text>
</v-card>
</v-dialog>

<!-- Background Verification Done & not done -->
<v-dialog v-model="showBGVDoneAndNotDone" max-width="600px" class="white">
  <v-card>
    <v-card-title class="py-2 px-3 title grey lighten-3">
      <div>{{typeAndHeaderTitle.comm_name}} - BGV Done and Not Done</div>
      <v-spacer></v-spacer>
      <v-btn icon small @click="showBGVDoneAndNotDone = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-divider></v-divider>
      <v-flex xs12>
        <div class="py-2 px-3 title grey lighten-3">Background verification not done</div>
        <v-data-table
        :headers="empListHeader"
        :items="bgvNotDoneEmp"
        hide-default-footer
        disable-pagination
        :mobile-breakpoint="0"
        >
        <template slot="item" slot-scope="props">
          <tr>
            <td>{{ props.item.serial_no }}</td>
            <td>{{ props.item.vendor_emp_id }}</td>
            <td>{{ props.item.emp_name }}</td>
            <td>{{ props.item.emp_desig }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
    <v-divider class="mb-2"></v-divider>
    <v-flex xs12>
      <div class="py-2 px-3 title grey lighten-3">Background verification done</div>
      <v-data-table
      :headers="empListHeader"
      :items="bgvDoneEmp"
      hide-default-footer
      disable-pagination
      :mobile-breakpoint="0"
      >
      <template slot="item" slot-scope="props">
        <tr>
          <td>{{ props.item.serial_no }}</td>
          <td>{{ props.item.vendor_emp_id }}</td>
          <td>{{ props.item.emp_name }}</td>
          <td>{{ props.item.emp_desig }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-flex>
</v-card-text>
</v-card>
</v-dialog>

<!-- left employee list -->
<v-dialog v-model="showLeftEmp" max-width="950px">
  <v-card>
    <v-card-title class="py-2 px-3 title grey lighten-3">
      <div>List of Left Empoyees</div>
      <v-spacer></v-spacer>
      <v-btn icon small @click="showLeftEmp = false"><v-icon>mdi-close</v-icon></v-btn>
      <v-flex xs12 class="pt-3">
        <v-download-as
        :headers="leftEmpHeader"
        :items="leftEmp"
        title="Left Employee List"
        ></v-download-as>
      </v-flex>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
      :headers="leftEmpHeader"
      :items="leftEmp"
      hide-default-footer
      disable-pagination
      :mobile-breakpoint="0"
      >
      <template slot="item" slot-scope="props">
        <tr>
          <td>{{ props.item.proj_name }}</td>
          <td>{{ props.item.vendor_emp_id }}</td>
          <td>{{ props.item.emp_name }}</td>
          <td>{{ props.item.emp_desig }}</td>
          <td>{{ props.item.emp_status }}</td>
          <td>{{ handy.formatDate(props.item.last_working_date) }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-card>
</v-dialog>

<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>
</v-col>
</v-row>
</v-container>
</template>

<script>
import VDownloadAs from '@/components/VDownloadAs.vue'
import config from '@/config/app-cfg'
import handy from '@/utils/handy'

export default {
  components: {
    'v-download-as': VDownloadAs
  },
  data () {
    return {
      dlgFromDate: false,
      dlgToDate: false,
      fromDate: '',
      toDate: '',
      config: config,
      handy: handy,
      sbarMsg: '',
      sbar: false,
      sbarCol: 'error',
      lAction: '',
      commList: [],
      empDet: [],
      empDetailsHeader: [
        { text: 'Community Name (Agreed | Billable)', value: 'comm_name', class: 'primary white--text', sortable: false },
        { text: 'Staff (Deployed | Undeployed)', value: 'staff', class: 'primary white--text', sortable: false },
        { text: 'AADHAR Collected | Pending', value: 'documents', class: 'primary white--text', sortable: false },
        { text: 'PF No Generated | Pending', value: 'pf', width: '100px', class: 'primary white--text', sortable: false },
        { text: 'ESI No Generated | Pending', value: 'esi', width: '100px', class: 'primary white--text', sortable: false },
        { text: 'ESI card not Generated', value: 'esic_card_not_generated', width: '100px', class: 'primary white--text', sortable: false },
        { text: 'Bank Acc. # Not Updated', value: 'bank_acc_no_updated', width: '130px', class: 'primary white--text' },
        { text: 'PAN No Updated', value: 'pan_no_updated', width: '90px', class: 'primary white--text' },
        { text: 'BGV Done | Not Done', value: 'verif', width: '90px', class: 'primary white--text', sortable: false },
      ],
      search: '',
      empListHeader: [
        { text: 'Serial No', value: 'serial_no' },
        { text: 'Employee Id', value: 'vendor_emp_id' },
        { text: 'Employee Name', value: 'emp_name' },
        { text: 'Employee Designation', value: 'emp_desig' }
      ],
      pfHeader: [
        { text: 'Serial No', value: 'serial_no' },
        { text: 'Employee Id', value: 'vendor_emp_id' },
        { text: 'Employee Name', value: 'emp_name' },
        { text: 'Employee Designation', value: 'emp_desig' },
        { text: 'PF Number', value: 'pf_no' }
      ],
      esiHeader: [
        { text: 'Serial No', value: 'serial_no' },
        { text: 'Employee Id', value: 'vendor_emp_id' },
        { text: 'Employee Name', value: 'emp_name' },
        { text: 'Employee Designation', value: 'emp_desig' },
        { text: 'ESI Number', value: 'esi_no' }
      ],
      empList: [],
      showEmpList: false,
      showLeftEmp: false,
      leftEmp: [],
      leftEmpHeader: [
        { text: 'Project Name', value: 'proj_name' },
        { text: 'Employee ID', value: 'vendor_emp_id' },
        { text: 'Employee Name', value: 'emp_name' },
        { text: 'Designation', value: 'emp_desig' },
        { text: 'Employee Status', value: 'emp_status' },
        { text: 'Last Working date', value: 'last_working_date' }
      ],
      typeAndHeaderTitle: {},
      showDepandUndepStaff: false,
      DepEmp: [],
      UnDepEmp: [],
      showDocCollectedAndPending: false,
      pendDocEmp: [],
      collectedDocEmp: [],
      pfEmp: [],
      pfPendEmp: [],
      showPFGeneratedandPend: false,
      showESIGeneratedandPend: false,
      esiEmp: [],
      esiPendEmp: [],
      showBGVDoneAndNotDone: false,
      bgvNotDoneEmp: [],
      bgvDoneEmp: []
    }
  },
  mounted () {
    this.lAction = 'view'
    var curDate = new Date()
    this.fromDate = handy.formatDBDate(curDate)
    this.toDate = handy.formatDBDate(curDate)
    this.loadEmployeeDet()
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    loadEmployeeDet () {
      var qry = {
        params: {
          from_dt: this.fromDate,
          to_dt: this.toDate,
          vendor_id: config.VENDOR_ID
        }
      }
      var tmpTotalArray = {
        total_staff: 0,
        document_pending: 0,
        document_collected: 0,
        pan_no_updated: 0,
        bank_acc_no_updated: 0,
        verif_done: 0,
        verif_not_done: 0,
        esi_opted_pending: 0,
        esi_opted: 0,
        pf_opted_pending: 0,
        pf_opted: 0,
        left_employee: 0,
        new_joinee: 0,
        esic_card_not_generated: 0,
        total_agreed: 0
      }
      this.empDet = []
      this.axios.get(config.API_URL + '/getEmployeeDet/', qry)
      .then(response => {
        response.data.forEach(rec => {
          tmpTotalArray.total_staff += rec.tot_staff
          tmpTotalArray.total_agreed += rec.agreed_head_count
          tmpTotalArray.document_pending += rec.document_pending
          tmpTotalArray.document_collected += rec.document_collected
          tmpTotalArray.pan_no_updated += rec.pan_no_updated
          tmpTotalArray.bank_acc_no_updated += rec.bank_acc_no_updated
          tmpTotalArray.verif_done += rec.verif_done
          tmpTotalArray.verif_not_done += rec.verif_not_done
          tmpTotalArray.esi_opted_pending += rec.esi_opted_pending
          tmpTotalArray.esic_card_not_generated += rec.esic_card_not_generated
          tmpTotalArray.esi_opted += rec.esi_opted
          tmpTotalArray.pf_opted_pending += rec.pf_opted_pending
          tmpTotalArray.pf_opted += rec.pf_opted
          tmpTotalArray.left_employee += rec.left_employee
          tmpTotalArray.new_joinee += rec.new_joinee

          this.empDet.push({
            comm_id: rec.comm_id,
            comm_name: rec.comm_name + ' (' + rec.agreed_head_count + '/' + rec.tot_staff + ')',
            tot_staff: rec.tot_staff,
            documents: rec.document_collected + ' | ' + rec.document_pending,
            pan_no_updated: rec.pan_no_updated,
            bank_acc_no_updated: rec.bank_acc_no_updated,
            verif: rec.verif_done + ' | ' + rec.verif_not_done,
            esi: rec.esi_opted + ' | ' + rec.esi_opted_pending,
            pf: rec.pf_opted + ' | ' + rec.pf_opted_pending,
            staff: rec.new_joinee + ' | ' + rec.left_employee,
            esic_card_not_generated: rec.esic_card_not_generated
          })
        })
        this.empDet.push({
          comm_name: 'Total (' + tmpTotalArray.total_agreed +' | ' + tmpTotalArray.total_staff + ')',
          tot_staff: tmpTotalArray.total_staff,
          documents: tmpTotalArray.document_collected + ' | ' + tmpTotalArray.document_pending,
          pan_no_updated: tmpTotalArray.pan_no_updated,
          bank_acc_no_updated: tmpTotalArray.bank_acc_no_updated,
          verif: tmpTotalArray.verif_done + ' | ' + tmpTotalArray.verif_not_done,
          esi: tmpTotalArray.esi_opted + ' | ' + tmpTotalArray.esi_opted_pending,
          pf: tmpTotalArray.pf_opted + ' | ' + tmpTotalArray.pf_opted_pending,
          staff: tmpTotalArray.new_joinee,
          esic_card_not_generated: tmpTotalArray.esic_card_not_generated
        })
        this.showLeftEmployees(false)
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    showListofStaffBasedonCommunity (curRec, headerType) {
      if (curRec.comm_id) {
        this.typeAndHeaderTitle.comm_name = curRec.comm_name.replace(/[^A-Za-z ]+/g, '')
        if (headerType === 'Staff (Deployed | Undeployed)') {
          this.showDeployedStaff(curRec)
        } else if (headerType === 'AADHAR Collected | Pending') {
          this.showAadharCollected(curRec)
          this.showAadharPending(curRec)
        } else if (headerType === 'PF No Generated | Pending') {
          this.showPFGenerated(curRec)
          this.showPFPending(curRec)
        } else if (headerType === 'ESI No Generated | Pending') {
          this.showESIGenerated(curRec)
          this.showESIPending(curRec)
        } else if (headerType === 'BGV Done | Not Done') {
          this.showBGVDone(curRec)
          this.showBGVNotDone(curRec)
        } else {
          var qry = {
            params: {
              from_dt: this.fromDate,
              to_dt: this.toDate,
              comm_id: curRec.comm_id,
              type: headerType,
              vendor_id: config.VENDOR_ID
            }
          }
          this.empList = []
          this.axios.get(config.API_URL + '/getEmployeeDetBasedonCommIdandType/', qry)
          .then(response => {
            if (response.data.length) {
              for (var i = 0; i < response.data.length; i++) {
                this.empList.push({
                  serial_no: i+1,
                  vendor_emp_id: response.data[i].vendor_emp_id,
                  emp_name: response.data[i].emp_name,
                  emp_desig: response.data[i].emp_desig
                })
              }
            }
            this.typeAndHeaderTitle.type = headerType
            this.showEmpList = true
          })
          .catch(err => {
            this.msg(err, 0)
          })
        }
      }
    },
    showDeployedStaff (curRec) {
      var qry = {
        params: {
          from_dt: this.fromDate,
          to_dt: this.toDate,
          comm_id: curRec.comm_id,
          type: 'Deployed Staff',
          vendor_id: config.VENDOR_ID
        }
      }
      this.DepEmp = []
      this.axios.get(config.API_URL + '/getEmployeeDetBasedonCommIdandType/', qry)
      .then(response => {
        if (response.data.length) {
          for (var i = 0; i < response.data.length; i++) {
            this.DepEmp.push({
              serial_no: i+1,
              vendor_emp_id: response.data[i].vendor_emp_id,
              emp_name: response.data[i].emp_name,
              emp_desig: response.data[i].emp_desig
            })
          }
        }
        this.showUndeployedStaff(curRec)
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    showUndeployedStaff (curRec) {
      var qry = {
        params: {
          from_dt: this.fromDate,
          to_dt: this.toDate,
          comm_id: curRec.comm_id,
          type: 'Undeployed Staff',
          vendor_id: config.VENDOR_ID
        }
      }
      this.UnDepEmp = []
      this.axios.get(config.API_URL + '/getEmployeeDetBasedonCommIdandType/', qry)
      .then(response => {
        if (response.data.length) {
          for (var i = 0; i < response.data.length; i++) {
            this.UnDepEmp.push({
              serial_no: i+1,
              vendor_emp_id: response.data[i].vendor_emp_id,
              emp_name: response.data[i].emp_name,
              emp_desig: response.data[i].emp_desig
            })
          }
        }
        this.showDepandUndepStaff = true
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    showAadharCollected (curRec) {
      var qry = {
        params: {
          from_dt: this.fromDate,
          to_dt: this.toDate,
          comm_id: curRec.comm_id,
          type: 'Documents Collected',
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getEmployeeDetBasedonCommIdandType/', qry)
      .then(response => {
        this.collectedDocEmp = []
        if (response.data.length) {
          for (var i = 0; i < response.data.length; i++) {
            this.collectedDocEmp.push({
              serial_no: i+1,
              vendor_emp_id: response.data[i].vendor_emp_id,
              emp_name: response.data[i].emp_name,
              emp_desig: response.data[i].emp_desig
            })
          }
        }
        this.showAadharPending(curRec)
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    showAadharPending (curRec) {
      var qry = {
        params: {
          from_dt: this.fromDate,
          to_dt: this.toDate,
          comm_id: curRec.comm_id,
          type: 'Documents Pending',
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getEmployeeDetBasedonCommIdandType/', qry)
      .then(response => {
        this.pendDocEmp = []
        if (response.data.length) {
          for (var i = 0; i < response.data.length; i++) {
            this.pendDocEmp.push({
              serial_no: i+1,
              vendor_emp_id: response.data[i].vendor_emp_id,
              emp_name: response.data[i].emp_name,
              emp_desig: response.data[i].emp_desig
            })
          }
        }
        this.showDocCollectedAndPending = true
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    showPFGenerated (curRec) {
      var qry = {
        params: {
          from_dt: this.fromDate,
          to_dt: this.toDate,
          comm_id: curRec.comm_id,
          type: 'PF Number Generated',
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getEmployeeDetBasedonCommIdandType/', qry)
      .then(response => {
        this.pfEmp = []
        if (response.data.length) {
          for (var i = 0; i < response.data.length; i++) {
            this.pfEmp.push({
              serial_no: i+1,
              vendor_emp_id: response.data[i].vendor_emp_id,
              emp_name: response.data[i].emp_name,
              emp_desig: response.data[i].emp_desig,
              pf_no: response.data[i].pf_no
            })
          }
        }
        this.showPFPending(curRec)
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    showPFPending (curRec) {
      var qry = {
        params: {
          from_dt: this.fromDate,
          to_dt: this.toDate,
          comm_id: curRec.comm_id,
          type: 'PF Opted Pending',
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getEmployeeDetBasedonCommIdandType/', qry)
      .then(response => {
        this.pfPendEmp = []
        if (response.data.length) {
          for (var i = 0; i < response.data.length; i++) {
            this.pfPendEmp.push({
              serial_no: i+1,
              vendor_emp_id: response.data[i].vendor_emp_id,
              emp_name: response.data[i].emp_name,
              emp_desig: response.data[i].emp_desig,
              pf_no: response.data[i].pf_no
            })
          }
        }
        this.showPFGeneratedandPend = true
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    showESIGenerated (curRec) {
      var qry = {
        params: {
          from_dt: this.fromDate,
          to_dt: this.toDate,
          comm_id: curRec.comm_id,
          type: 'ESI Number Generated',
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getEmployeeDetBasedonCommIdandType/', qry)
      .then(response => {
        this.esiEmp = []
        if (response.data.length) {
          for (var i = 0; i < response.data.length; i++) {
            this.esiEmp.push({
              serial_no: i+1,
              vendor_emp_id: response.data[i].vendor_emp_id,
              emp_name: response.data[i].emp_name,
              emp_desig: response.data[i].emp_desig,
              esi_no: response.data[i].esi_no
            })
          }
        }
        this.showESIPending(curRec)
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    showESIPending (curRec) {
      var qry = {
        params: {
          from_dt: this.fromDate,
          to_dt: this.toDate,
          comm_id: curRec.comm_id,
          type: 'ESI Opted Pending',
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getEmployeeDetBasedonCommIdandType/', qry)
      .then(response => {
        this.esiPendEmp = []
        if (response.data.length) {
          for (var i = 0; i < response.data.length; i++) {
            this.esiPendEmp.push({
              serial_no: i+1,
              vendor_emp_id: response.data[i].vendor_emp_id,
              emp_name: response.data[i].emp_name,
              emp_desig: response.data[i].emp_desig,
              esi_no: response.data[i].esi_no
            })
          }
        }
        this.showESIGeneratedandPend = true
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    showBGVDone (curRec) {
      var qry = {
        params: {
          from_dt: this.fromDate,
          to_dt: this.toDate,
          comm_id: curRec.comm_id,
          type: 'BGV Done',
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getEmployeeDetBasedonCommIdandType/', qry)
      .then(response => {
        this.bgvDoneEmp = []
        if (response.data.length) {
          for (var i = 0; i < response.data.length; i++) {
            this.bgvDoneEmp.push({
              serial_no: i+1,
              vendor_emp_id: response.data[i].vendor_emp_id,
              emp_name: response.data[i].emp_name,
              emp_desig: response.data[i].emp_desig
            })
          }
        }
        this.showBGVNotDone(curRec)
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    showBGVNotDone (curRec) {
      var qry = {
        params: {
          from_dt: this.fromDate,
          to_dt: this.toDate,
          comm_id: curRec.comm_id,
          type: 'BGV Not Done',
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getEmployeeDetBasedonCommIdandType/', qry)
      .then(response => {
        this.bgvNotDoneEmp = []
        if (response.data.length) {
          for (var i = 0; i < response.data.length; i++) {
            this.bgvNotDoneEmp.push({
              serial_no: i+1,
              vendor_emp_id: response.data[i].vendor_emp_id,
              emp_name: response.data[i].emp_name,
              emp_desig: response.data[i].emp_desig
            })
          }
        }
        this.showBGVDoneAndNotDone = true
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    showLeftEmployees (showemplist) {
      var qry = {
        params: {
          from_dt: this.fromDate,
          to_dt: this.toDate,
          vendor_id: config.VENDOR_ID
        }
      }
      this.leftEmp = []
      this.axios.get(config.API_URL + '/getLeftEmployeeDet/', qry)
      .then(response => {
        this.leftEmp = response.data
        if (showemplist) {
          this.showLeftEmp = true
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    }
  }
}
</script>
